import handleLogin from './handle-login';
import {
  NETWORK_ERROR,
  FAILED_TO_FETCH_ERROR,
  REFRESHING_TOKEN_KEY,
  REFRESH_KEY
} from '../constants';
import { REFRESH_LOGIN_MUTATION } from '../mutations';
import handleLogout from './handle-logout';

const handleRefresh = async (token, client) => {
  window.localStorage.setItem(REFRESHING_TOKEN_KEY, true);
  let result = null;
  try {
    const refreshToken = token || window.localStorage.getItem(REFRESH_KEY);
    if (!refreshToken) {
      throw new Error('No refresh token found');
    }
    const { data } = await client.mutate({
      variables: { refreshToken },
      mutation: REFRESH_LOGIN_MUTATION
    });

    result = await handleLogin(data, client, true);
    window.localStorage.removeItem(REFRESHING_TOKEN_KEY);
  } catch (error) {
    const { message } = error;
    window.localStorage.removeItem(REFRESHING_TOKEN_KEY);
    if (message.indexOf(NETWORK_ERROR) === -1 && message.indexOf(FAILED_TO_FETCH_ERROR) === -1) {
      await handleLogout(client);
    }
  }

  window.localStorage.removeItem(REFRESHING_TOKEN_KEY);
  return result;
};

export default handleRefresh;
